import $ from 'jquery';

//   const $ = window.$;
$(function () {
  $('.js-nav a, .js-connect').click(function (e) {
    e.preventDefault();
    $('body, html').animate(
      {
        scrollTop: $($.attr(this, 'href')).offset().top,
      },
      750
    );
  });
});
